import { useNavigate, useParams } from 'react-router-dom';
import { useState } from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator
} from '@/components/ui/breadcrumb';
import { AppTitle } from '@/components/app-header/app-header';
import { CreateSegmentDialog } from './components/create-segment-dialog';
import { SegmentsTable } from './components/segments-table';
import { columns } from './components/columns';
import { useSegments } from '@/hooks/use-segments';

export default function SegmentsPage() {
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { slug } = useParams<{ slug: string }>();

  const { segments, loading, error, refetch } = useSegments();

  const tableError = error
    ? {
        message: error.message,
        retry: refetch
      }
    : undefined;

  const handleRowClick = (segment: { id: string }) => {
    if (!slug) {
      console.error('Merchant slug not found in URL');
      return;
    }
    void navigate(`/merchants/${slug}/segments/builder/${segment.id}`);
  };

  return (
    <>
      <AppTitle>
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbSeparator />
            <BreadcrumbItem>
              <BreadcrumbPage className="text-base">Segments</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>
      </AppTitle>

      <div className="space-y-6">
        <SegmentsTable
          data={segments}
          columns={columns}
          isLoading={loading}
          error={tableError}
          onCreateClick={() => {
            setIsCreateDialogOpen(true);
          }}
          onRowClick={handleRowClick}
        />
      </div>

      <CreateSegmentDialog open={isCreateDialogOpen} onOpenChange={setIsCreateDialogOpen} />
    </>
  );
}
